















import { defineComponent, toRefs } from '@vue/composition-api';
import { useContextualCommentingStore } from '../../store/contextual-commenting.store';
import { t } from '../../../helpers/translation.helper';

export default defineComponent({
  props: {
    commentId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const store = useContextualCommentingStore();
    const { draftIdUpdating, draftIdUpdated } = toRefs(store);
    return { t, draftIdUpdating, draftIdUpdated };
  },
});
